import { Grid, Skeleton } from '@mui/material';

export const AdminInvoiceTemplateSkeleton = () => {
  const CustomSkeleton = ({ height = '18px', width = '95%' }) => <Skeleton animation={false} variant='text' sx={{ height, width }} />;
  return (
    <Grid container px={1} justifyContent='space-between'>
      <Grid item xs={9}>
        <Grid item xs={12}>
          <CustomSkeleton height='60px' width='50%' />
        </Grid>
        <Grid container justifyContent='space-between'>
          <Grid item xs={5}>
            <Grid item xs={9}>
              <CustomSkeleton />
            </Grid>
            <Grid item xs={6}>
              <CustomSkeleton />
            </Grid>
            <Grid item xs={7}>
              <CustomSkeleton />
            </Grid>
          </Grid>

          <Grid item xs={5}>
            <Grid item xs={8}>
              <CustomSkeleton />
            </Grid>
            <Grid item xs={6}>
              <CustomSkeleton />
            </Grid>
            <Grid item xs={7}>
              <CustomSkeleton />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={3} mt={2}>
        <Grid item xs={12}>
          <CustomSkeleton height='40px' />
        </Grid>
        <Grid item xs={12}>
          <CustomSkeleton height='40px' />
        </Grid>
      </Grid>
    </Grid>
  );
};
